import React from 'react';
import { Step } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const Steps = (props) => {
  const { t } = props;
 
  return (
    <Step.Group ordered>
      <Step
        completed={!!props.competitionOk}
        active={props.activeStep === 0}>
        <Step.Content>
          <Step.Title>{t('private:addWorkshop.steps.competition')}</Step.Title>
          <Step.Description>{t('private:addWorkshop.steps.competition_i')}</Step.Description>
        </Step.Content>
      </Step>

      <Step
        completed={!!props.userOk}
        active={props.activeStep === 1}>
        <Step.Content>
          <Step.Title>{t('private:addWorkshop.steps.participant')}</Step.Title>
          <Step.Description>{t('private:addWorkshop.steps.participant_i')}</Step.Description>
        </Step.Content>
      </Step>

      <Step
        completed={!!props.extraOk}
        active={props.activeStep === 2}>
        <Step.Content>
          <Step.Title>{t('private:addWorkshop.steps.extra')}</Step.Title>
          <Step.Description>{t('private:addWorkshop.steps.extra_i')}</Step.Description>
        </Step.Content>
      </Step>
      <Step
        completed={!!props.rulesOk}>
        <Step.Content>
          <Step.Title>{t('private:addWorkshop.steps.rules')}</Step.Title>
          <Step.Description>{t('private:addWorkshop.steps.rules_i')}</Step.Description>
        </Step.Content>
      </Step>
    </Step.Group>
  );
};

export default withNamespaces('private')(Steps);



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Steps.js